import { render, staticRenderFns } from "./JobsEditView.vue?vue&type=template&id=48b5cd06&scoped=true&"
import script from "./JobsEditView.vue?vue&type=script&lang=js&"
export * from "./JobsEditView.vue?vue&type=script&lang=js&"
import style0 from "./JobsEditView.vue?vue&type=style&index=0&id=48b5cd06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b5cd06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
